import React, { useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./_features/App";
import { config } from "config";

import "./index.css";
import { StorageKeys } from "enums/StorageKeys";
import { PaperCompanies } from "enums/PaperCompanies";

function PaperCompanyValues() {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    function loadDynamicFavicon() {
        const existingFavicon = document.getElementById(
            "dynamic-favicon"
        ) as HTMLLinkElement | null;
        if (existingFavicon) {
            // Favicon link already exists, remove it to avoid flash of pre-existing content
            existingFavicon.remove();
        }

        const favicon = document.createElement("link");
        favicon.id = "dynamic-favicon";
        favicon.rel = "icon";

        const host = window.location.hostname.toLowerCase();

        const isGSL = host.endsWith("gslcustomer.com") || process.env.REACT_APP_IS_GSL === "true";
        const version = Date.now(); // Cache buster

        favicon.href = isGSL
            ? `/images/gslfavicon.png?v=${version}`
            : `/images/favicon.ico?v=${version}`;
        document.head.appendChild(favicon);
    }

    function loadDynamicPageTitle(values: any) {
        document.title = values.companyName
            ? `${values.companyName} Customer Portal`
            : "Customer Portal";
    }

    fetch(config.app.paperCompanyCdn)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            const host = window.location.hostname.toLowerCase();
            const companyKey =
                host.endsWith("gslcustomer.com") || process.env.REACT_APP_IS_GSL === "true"
                    ? PaperCompanies.GSL
                    : "";
            const values =
                companyKey === PaperCompanies.GSL ? data[companyKey.toLowerCase()] : { ...data };

            // Remove GSL company values (if not gsl host) to avoid confusion
            if (companyKey !== PaperCompanies.GSL && values.gsl) {
                delete values.gsl;
            }

            sessionStorage.setItem(StorageKeys.PaperCompanyValues, JSON.stringify(values));
            setErrorMessage(null);
            loadDynamicFavicon();
            loadDynamicPageTitle(values);

            document.documentElement.setAttribute("data-app-ready", "true");
        })
        .catch((error) => {
            console.error("Failed to load PaperCompanyValues from CDN:", error);
            setErrorMessage("An unexpected error has occurred. Please try again later.");
        });

    if (errorMessage && errorMessage.length > 0) {
        return (
            <div className="row" style={{ padding: 10 }}>
                <div className="col-12">
                    <div>
                        <label className="text-danger" aria-live="assertive" role="alert">
                            {errorMessage}
                            <br />
                            <br />
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}

ReactDOM.render(
    <React.StrictMode>
        <PaperCompanyValues />
    </React.StrictMode>,
    document.getElementById("root")
);
